module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/028-puerto-rico-2b3711557aa3723456d964bb8ee10105.svg";